import moment from "moment"
import React, { useEffect } from "react"

const VATServiceDateCalculate = ({
  firstPeriodEnd,
  setFirstPeriodEnd,
  frequency,
  setFrequency,
  currentPeriodEnd,
  setCurrentPeriodEnd,
  currentPeriodDue,
  setCurrentPeriodDue,
  label1,
  label2,
  label3,
  label4,
  static_frequency,
  isReadOnly,
  datePresent = false,
  setDatePresent,
  firstPeriodError,
  frequencyError,
}) => {
  // Jan/Apr/Jul/Oct
  // Feb/May/Aug/Nov
  // Mar/June/Sept/Dec

  // const QUARTERLY = {
  // }

  useEffect(() => {
    if (firstPeriodEnd && frequency && !datePresent) {
      dateChangeLogin()
    }
  }, [firstPeriodEnd, frequency, datePresent])

  function dateChangeLogin() {
    let periodEndDate, dueDate
    const currentDate = moment()

    switch (frequency) {
      case "monthly":
        dueDate = getDueDate(currentDate, 1)
        currentDate.endOf("month")
        periodEndDate = currentDate.format("YYYY-MM-DD")
        break
      // case 'quarterly':
      //     let first = moment(firstPeriodEnd);
      //     // first.set('year', currentDate.year());

      //     do {
      //         first.add(3, 'months')
      //     } while (currentDate.isBefore(first));

      //     first.endOf("month");

      //     periodEndDate = first.format("YYYY-MM-DD")
      //     dueDate = getDueDate(first, 1)
      //     break;
      case "quarterly":
        let first = moment(firstPeriodEnd).startOf("day") // Make sure first starts from the beginning of the day
        let current = moment(currentDate).startOf("day") // Also ensure currentDate is at the start of the day

        // Iterate by 3 months until 'first' is after 'current'
        do {
          first.add(3, "months") // Add 3 months in each iteration
        } while (first.isBefore(current)) // Keep iterating until first is on or after the current date

        // Ensure 'first' ends on March 31, 2025 (set the period end date to March 31, 2025)
        if (first.isBefore("2025-03-31", "day")) {
          first = moment("2025-03-31").startOf("day")
        }

        first.endOf("month") // Make sure 'first' is set to the end of the month

        periodEndDate = first.format("YYYY-MM-DD")
        dueDate = getDueDate(first, 1)
        break

      case "annually":
        const temPeriodEnd = moment(firstPeriodEnd)
        temPeriodEnd.set("year", currentDate.year()) // Set the year to the current year

        // Set time to midnight to avoid time issues in comparison
        currentDate.startOf("day")
        temPeriodEnd.startOf("day")

        // Check if the current date has passed the adjusted period end for the current year
        if (currentDate.isAfter(temPeriodEnd)) {
          temPeriodEnd.add(1, "years") // Move to next year if the date has passed
        }

        periodEndDate = temPeriodEnd.format("YYYY-MM-DD")
        dueDate = getDueDate(temPeriodEnd, 2)
        break
    }

    setCurrentPeriodEnd(periodEndDate)
    setCurrentPeriodDue(dueDate)
  }

  function getDueDate(date, type) {
    const nextDate = moment(date, "YYYY-MM-DDTHH:mm")

    if (type === 2) {
      nextDate.add(2, "months")
    } else {
      nextDate.add(1, "months") // Move to the next month
      nextDate.endOf("month") // Set to the last day of that month
      nextDate.add(7, "days")
    }

    return moment(nextDate).format("YYYY-MM-DD")
  }

  return (
    <div className="row mt-4">
      <div className="col-md-4">
        <label>
          {label1}{" "}
          <span className="text-danger">
            {label1 === "First VAT Period End " ? "*" : ""}
          </span>{" "}
        </label>
        <input
          type="date"
          value={firstPeriodEnd}
          disabled={isReadOnly}
          onChange={e => {
            // const selectedDate = moment(e.target.value)
            // const endOfMonth = selectedDate.clone().endOf("month")
            // // Set the end date of the month with the exact same time
            // const formattedEndOfMonth = moment(endOfMonth).format("YYYY-MM-DD")
            // setVATCurrentPeriodDueDate(formattedEndOfMonth)
            if (datePresent) setDatePresent(false)
            setFirstPeriodEnd(e.target.value)
          }}
          className="form-control input-field"
        />
        <span className="error">{firstPeriodError}</span>
      </div>

      <div className="col-md-2 mb-3">
        <label>
          {label2}{" "}
          <span className="text-danger">
            {label2 === "VAT Frequency " ? "*" : ""}
          </span>{" "}
        </label>
        <select
          className="form-select input-field"
          disabled={isReadOnly}
          value={frequency}
          onChange={e => {
            if (datePresent) setDatePresent(false)
            setFrequency(e.target.value)
          }}
          style={{ paddingRight: "35px" }}
        >
          <option value="">Select Frequency</option>
          {/* {
                                vat_period_options?.map((option) => (
                                    <option key={option.id} value={option.id}>{option.vatPeriod}</option>
                                ))
                            } */}

          {static_frequency
            ?.slice()
            .sort((a, b) => a.label.localeCompare(b.label))
            ?.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
        <span className="error">{frequencyError}</span>
      </div>

      <div className="col-md-3 mb-3">
        <label>{label3}</label>
        <input
          type="date"
          value={currentPeriodEnd}
          // onChange={(e) => setVATCurrentPeriodDueDate(e.target.value)}
          className="form-control input-field"
          readOnly
        />
      </div>

      <div className="col-md-3  mb-md-1 mb-3">
        <label>{label4}</label>
        <input
          type="date"
          value={currentPeriodDue}
          readOnly
          className="form-control input-field"
        />
      </div>
    </div>
  )
}

export default VATServiceDateCalculate
